import React from 'react'

import { RewardListItem } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'

import { ACCOUNT_ROUTES } from 'App/constants'

import { MergedOffers } from '../../../types'
import styles from '../MyRewardsList.scss'

const renderVouchers = (rewards: MergedOffers[], handleClick): React.ReactElement[] =>
  rewards.map(
    ({
      activeOfferExpiresAt,
      amountFormatted,
      headline,
      isOfferActive,
      isValidFromEnable,
      offerKey,
      personalizedExpireDateFormatted,
      srcImage,
      startDateTimeFormatted,
      typeCat,
      isValidUntilEnable,
      dateInfoText,
      offerPropositionId,
    }) => {
      return (
        <RewardListItem
          activeOfferExpiresAt={activeOfferExpiresAt}
          amountFormatted={amountFormatted}
          headline={headline || ''}
          isOfferActive={isOfferActive}
          isValidFromEnable={isValidFromEnable}
          isValidUntilEnable={isValidUntilEnable}
          key={offerKey}
          personalizedExpireDateFormatted={personalizedExpireDateFormatted}
          srcImage={srcImage}
          startDateTimeFormatted={startDateTimeFormatted}
          typeCat={typeCat}
          className={styles.vouchers}
          validFromText={dateInfoText}
          countdownTranslatedText={getLabelFromStorage('hub.register.by')}
          rewardDetailRoute={`${ACCOUNT_ROUTES.RewardDetail.path}/${offerPropositionId}`}
          handleClick={() => handleClick(offerKey, offerPropositionId)}
        />
      )
    },
  )

export default renderVouchers
